<template>
    <div class="w-[95%] m-4 relative flex flex-col items-center justify-center bg-white rounded-lg shadow-sm">
        <div class="p-8">
            <h1 class="text-xl font-semibold text-gray-700">Personal details</h1>
            <p class="text-sm text-gray-500">
                Choose how you’d like to be identified by others who have access to projects you work with. If no name
                is provided, Folia will default to your email address. The email address associated with your account is
                listed here (cannot be changed).
            </p>
            <div class="">
                <div class="mt-4 space-4 flex flex-col md:flex-row">
                    <div class="flex-1  m-2">
                        <label for="name" class="block text-sm font-medium text-gray-500">Name</label>
                        <input v-model="name" type="text" id="name"
                            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm text-gray-700"
                            placeholder="Enter your name" />
                    </div>
                    <div class="flex-1 m-2">
                        <label for="email" class="block text-sm font-medium text-gray-500">Email</label>
                        <input v-model="email" type="email" id="email"
                            class="mt-1 block w-full bg-gray-200 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm text-gray-700"
                            disabled />
                    </div>

                </div>
                <div class="flex justify-end relative w-full h-full">
                    <button @click="saveDetails" type="button" class="mt-4 w-full md:w-32 cursor-pointer rounded-md border border-transparent bg-gray-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-600 
                        float-right" :disabled="isActionInProgress">
                        Save
                    </button>


                </div>
                <div class="flex justify-center relative w-full h-full">
                    <button @click="clearIndexDb" type="button" class="mt-4 w-full md:w-48  cursor-pointer rounded-md border border-transparent bg-orange-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-orange-400 
                        ">
                        Clear profile cache
                    </button>
                </div>
            </div>
        </div>
        <div v-if="isActionInProgress"
            class="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 backdrop-blur-sm rounded-lg shadow-sm flex items-center justify-center">
            <DefaultLoader />
        </div>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import ProfileService from '../../../../service/profileService';
import DefaultLoader from '../../loaders/defaultLoader.vue';
import { useRouter } from "vue-router";

export default {
    name: "ProfileSettings",
    components: {
        DefaultLoader
    },
    setup() {
        const router = useRouter();
        const name = ref('');
        const email = ref('');
        const initialName = ref('');
        const profileService = new ProfileService();
        const isActionInProgress = ref(false);
        onMounted(async () => {
            isActionInProgress.value = true;
            const { name: n = null, email: e = '', profilePicture = '' } = await profileService.getMyProfile();
            name.value = n;
            email.value = e;
            initialName.value = n;
            isActionInProgress.value = false;
        });
        const saveDetails = async () => {
            try {
                if (name.value !== initialName.value) {
                    isActionInProgress.value = true;
                    await profileService.updateUserProfile({ email: email.value, name: name.value });
                }

            } catch (error) {
                console.log(error);

            } finally {
                isActionInProgress.value = false;
            }

        };
        const clearIndexDb = () => {
            indexedDB.deleteDatabase('FOLIA_CACHE');
            router.push({ name: 'home' }).then(() => {
                location.reload();
            });
        }
        return {
            name, email,
            saveDetails,
            isActionInProgress,
            clearIndexDb
        };
    },
};
</script>

<style scoped></style>